import { Logger, LoggerService } from "@Shared/logger";
import { AUTH0_CONST, Auth0Service } from "@Modules/auth_module";
import { PipelineContext, PipelineStep } from "@Modules/pipeline_module/_base";

import { EntitlementService } from "@Modules/entitlement_module";
import { UrlUtil } from "@Shared/utils";

export class ClearUserDataStep implements PipelineStep {
    private auth0Service: Auth0Service;
    private entitlementService: EntitlementService;
    private Logger: Logger = LoggerService.createLogger("ClearUserDataStep");

    
    constructor() {
        this.Logger.trace("****  CTOR ****");
        
    }
    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....", context);
        this.auth0Service = Auth0Service.Instance;
        UrlUtil.removeQueryParam(AUTH0_CONST.clearUserParam);
        await this.auth0Service.logout();
        
        return null;
        


    }
}
